exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sucsess[data-v-96076d62],.sucsess__text[data-v-96076d62]{margin-bottom:18px}.sucsess__text[data-v-96076d62]{font-family:inherit;font-size:16px;line-height:1.25;color:#484848}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-96076d62","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/certificate/components/sucsess/Sucsess.vue
// module id = d7757e4b61638bfbd2e5
// module chunks = 9